import { PureComponent } from 'react';
import React from 'react';
import ExitToAppIcon from 'mdi-react/ExitToAppIcon';
import { Divider } from '@material-ui/core';
import { WithStyles } from 'decorators/withStyles';
import { IAccount } from 'interfaces/accounts';
import Item from './Item';
import authService from 'services/auth';
import { checkStorage } from 'helpers/checkStorage';
import userService from 'services/user';

interface IProps {
  classes?: any;
}

interface IState {
  accounts: IAccount[];
}
@WithStyles(() => ({
  container: {
    width: '12.5rem',
    backgroundColor: '#fff',
    borderRadius: '0.25rem',
    padding: '0.5rem',
    zIndex: 9999,
    position: 'absolute',
    left: '1.625rem',
    top: '5.313rem',
    boxShadow: '5px 6px 10px rgba(0, 0, 0, 0.25)',
    '&::after': {
      content: '""',
      position: 'absolute',
      marginLeft: '-5px',
      borderWidth: '5px',
      borderStyle: 'solid',
      borderColor: 'transparent transparent #fff transparent',
      bottom: '100%',
      left: '50%'
    }
  },

  wrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontWeight: 600,
    color: '#292929'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0.625rem 0'
  },

  logout: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    margin: '0.5rem',
    cursor: 'pointer'
  }
}))
export default class SwitchAccount extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { accounts: [] };
  }

  componentDidMount(): void {
    userService.getAccounts().subscribe(accounts => {
      const accontsFiltered = accounts.filter(account => !account.isMe);

      this.setState({ accounts: accontsFiltered });
    });
  }

  render() {
    const { container, wrapper, title, content, logout } = this.props.classes;
    const { accounts } = this.state;

    const showList = accounts?.length >= 1 && checkStorage();
    return (
      <div className={container}>
        <div className={wrapper}>
          {showList && (
            <>
              <div className={title}>Contas:</div>

              <div className={content}>
                {accounts.map(account => (
                  <Item account={account} key={account.id} />
                ))}
              </div>
              <Divider />
            </>
          )}
          <div
            className={logout}
            onClick={() => {
              authService.logout();
            }}
          >
            <ExitToAppIcon />
            <span>Sair</span>
          </div>
        </div>
      </div>
    );
  }
}
